import { Link } from 'react-router-dom';

const rules = [
  {
    step: '01',
    title: '访问官网入口',
    desc: '通过每日大赛Yandex官网入口进入平台',
  },
  {
    step: '02',
    title: '注册Yandex账户',
    desc: '使用手机号或邮箱完成免费注册',
  },
  {
    step: '03',
    title: '完成实名认证',
    desc: '上传有效证件，一个工作日审核',
  },
  {
    step: '04',
    title: '每日报名参赛',
    desc: '上午10:00开启报名，下午14:00开赛',
  },
];

export default function RulesPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Yandex每日大赛参赛流程
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            四步轻松参与每日竞技，赢取丰厚奖励
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {rules.map((rule, index) => (
            <div key={rule.step} className="relative">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 h-full">
                <span className="text-4xl font-heading font-bold text-primary-200">
                  {rule.step}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mt-3 mb-2 font-heading">
                  {rule.title}
                </h3>
                <p className="text-sm text-foreground-600">{rule.desc}</p>
              </div>
              {index < rules.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-s-line text-2xl text-foreground-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/competition-rules"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整规则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}